<template>
    <v-card :max-height="maxHeight" :min-height="minHeight" class="d-flex flex-column zoezi-edit-font">
        <v-card-title class="headline zoezi-edit-color pb-4" v-if="showHeader">{{$translate('Component tree')}}
            <v-btn right icon @click="$emit('close')" class="ml-auto d-flex"><v-icon class="white--text">mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text style="overflow-y: auto">
            <v-treeview
                color="zoezi-edit-color"
                style="cursor: pointer"
                :items="treeItems"
                :active="active"
                activatable
                open-all
                @update:active="treeChange"
            >
                <template v-slot:prepend="{ item }">
                    <v-icon v-if="item.icon">
                        {{item.icon}}
                    </v-icon>
                </template>
            </v-treeview>
        </v-card-text>

        <v-spacer/>

        <v-card-actions v-if="showClose">
            <v-spacer></v-spacer>

            <v-btn
                color="zoezi-edit-color"
                text
                @click="$emit('close')"
            >
                {{$translate('Close')}}
            </v-btn>

        </v-card-actions>
    </v-card>
</template>

<script>
import components from '../component.js'
export default {
    name: 'ComponentTree',

    props: ['show-header', 'show-close', 'min-height', 'max-height'],

    data: () => ({
        treeItems: [],
        active: []
    }),
    methods: {
        getComponentTree() {
            let hasZoeziChild = function(x) {
                if (x.zoezi) {
                    return true;
                }

                return x.children.find(hasZoeziChild);
            };

            let buildComponentTree = (node, items) => {
                const cc = components.getAllComponents();
                let zoeziComponent = cc.find(x => x.name == node.$options.name);
                let name = this.$translate(zoeziComponent ? zoeziComponent.zoezi.title : node.$options.name);
                let item = {id: node._uid, name, children: [], zoezi: !!zoeziComponent, icon: zoeziComponent && zoeziComponent.zoezi.icon };
                node.$children.forEach((x) => buildComponentTree(x, item.children))

                if (hasZoeziChild(item)) {
                    if (!item.zoezi && item.children.length) {
                        item.children.forEach(x => items.push(x));
                    } else {
                        items.push(item);
                    }
                }
            };

            let locateComponent = function(node, name) {
                if (node.$options.name == name) {
                    return node;
                }

                let res = null;
                node.$children.forEach(x => {
                    let c = locateComponent(x, name);
                    if (!res) {
                        res = c;
                    }
                })

                return res;
            };

            let items = [];
            buildComponentTree(locateComponent(this.$root, 'zoezi-root'), items);
            return items;
        },
        treeChange(items) {
            if (items && items.length == 1) {
                let locateComponent = function(node, id) {
                    if (node._uid == id) {
                        return node;
                    }

                    let res = null;
                    node.$children.forEach(x => {
                        let c = locateComponent(x, id);
                        if (!res) {
                            res = c;
                        }
                    })

                    return res;
                };

                let selectedComponent = locateComponent(this.$root, items[0]);
                this.$emit('select', selectedComponent);
            }
        }
    },
    created() {
        this.treeItems = this.getComponentTree();
        if (this.$store.state.editComponent) {
            this.active = [this.$store.state.editComponent._uid];
        }
    }
}
</script>
